<mat-icon
    *ngIf="isActive && config?.iconType === 1"
    class="state-icon-renderer"
    [svgIcon]="config?.icon"
    matTooltipShowDelay="500"
    [matTooltip]="config?.tooltip | translate"
    [style.font-size]="getFontSize()"
></mat-icon>
<mat-icon
    *ngIf="isActive && (!config?.iconType || config?.iconType === 0)"
    class="state-icon-renderer"
    matTooltipShowDelay="500"
    [matTooltip]="config?.tooltip | translate"
    [style.font-size]="getFontSize()"
    [style.color]="getColorStyle()"
    >{{ config?.icon }}</mat-icon
>
<mat-icon
    *ngIf="isActive && config?.iconType === 2"
    fontSet="estensa-icons"
    class="state-icon-renderer"
    matTooltipShowDelay="500"
    [matTooltip]="config?.tooltip | translate"
    [style.font-size]="getFontSize()"
    >{{ config?.icon }}</mat-icon
>
